import EditApplicationNameModal from "./EditApplicationNameModal";

export default EditApplicationNameModal;
